import {
  EnrollmentStatusResponseSchema,
  NewOccupantResponseSchema,
  type EnrollmentStatusResponse,
  type NewOccupantRequest,
  type NewOccupantResponse,
} from '@rheora/enrollment-contract';

import { bffGet, bffPost } from './bff-client';

/**
 * Typed fetchers for the E-SF07 anonymous status page. Thin: request + validate
 * against the shared contract schema. Pages call the `status.queries` hooks,
 * never these directly.
 *
 * ── THE TOKEN IS THE CAPABILITY (AC2) ──────────────────────────────────────
 * No session cookie, no login: the single-purpose, expiring status token (from
 * the pre-activation email) rides in the URL PATH. The browser never sends a
 * tenant id or credential — the BFF resolves the enrollment from the token
 * server-side. A bad/expired token is a 404 (`BffError` with status 404).
 */

/** Path with the token as a path segment (never a query string — it is a capability). */
function statusPath(token: string): string {
  return `/bff/status/${encodeURIComponent(token)}`;
}

/** Read the live enrollment lifecycle for a status token. */
export async function getEnrollmentStatus(token: string): Promise<EnrollmentStatusResponse> {
  return bffGet(statusPath(token), EnrollmentStatusResponseSchema);
}

/**
 * Submit the switch-hold self-serve resolution (AC1): New Occupant Statement +
 * proof-of-occupancy upload. Fails loud when the CRM ops-case endpoint is not
 * wired yet (a 501 → honest "not available yet"), never a fake success.
 */
export async function postNewOccupant(
  token: string,
  request: NewOccupantRequest,
): Promise<NewOccupantResponse> {
  return bffPost(`${statusPath(token)}/new-occupant`, request, NewOccupantResponseSchema);
}
